import classNames from 'classnames';

const Button = (props) => {
    const { 
        children, 
        className, 
        disabled = false,
        leftIcon = null,
        rightIcon = null, 
        color = null,
        fillContainer,
        transparent = false,
        mobile = false,
        mobileIcon = leftIcon || rightIcon,
        href = null,
        responsive = false,
    } = props;

    const classes = classNames({
        'button': true,
        'button--disabled': disabled,
        'button--mobile': mobile,
        'button--fill': fillContainer,
        'button--transparent': transparent,
        'button--responsive': responsive,
        [`button--${color}`]: color !== null,
        [className]: color === null,
    });

    const render = () => {
        if (mobile && mobileIcon !== null) {
            return mobileIcon;
        }

        return (
            <>
                { leftIcon && leftIcon }
                <p>{ children }</p>
                { rightIcon && rightIcon }
            </>
        )
    }

    if (href !== null) {
        return (
            <a { ...props } disabled={disabled} className={classes}>
                { render() }
            </a>
        )
    }

    return (
        <button { ...props } disabled={disabled} className={classes}>
            { render() }
        </button>
    )
}

export default Button;
